import NavBar from "../Navbar/Navbar";
import SideBar from "../Sidebar/SideBar";
import PropTypes from "prop-types";
import "./Devices.css";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import {
  getAllDevice,
  createDevice,
  getDeviceDetails,
  editDevice,
  deleteDevice,
  bulkcreateDevice,
  DeviceHistory,
  downloadSampleCsv,
} from "./api";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import { useEffect, useState, useRef } from "react";
import { CircularProgress } from "@material-ui/core";
import getCookie, { setAdminCookie, userState } from "../../Atom";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import Box from "@mui/material/Box";
import TableSortLabel from "@mui/material/TableSortLabel";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import ReactPaginate from "react-paginate";
import { useHistory } from "react-router-dom";
// import deviceCSV from "../../assets/csv/deviceCSV.csv";
import Snackbar from "@mui/material/Snackbar";
import * as React from "react";
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import { baseUrl } from "../Base_url";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
const headCells = [
  {
    id: "_id",
    numeric: false,
    disablePadding: true,
    label: "Serial Id",
  },
  {
    id: "name",
    numeric: false,
    disablePadding: true,
    label: "Device Name",
  },
  {
    id: "schoolDistrict",
    numeric: true,
    disablePadding: true,
    label: "School District",
  },
  {
    id: "school",
    numeric: true,
    disablePadding: true,
    label: "School",
  },
  {
    id: "teacher",
    numeric: false,
    disablePadding: true,
    label: "Teacher",
  },
  {
    id: "assignedAt",
    numeric: true,
    disablePadding: true,
    label: "Assigned on",
  },
];

function EnhancedTableHead(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={"center"}
            padding={"normal"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
              {headCell.id !== "teacher" ? (
            <TableSortLabel
              className="sort-header"
              sx={{ display: "flex",justifyContent:'left !important' }}
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
            </TableSortLabel> ) : (
              headCell.label
            )}
          </TableCell>
        ))}

        <TableCell align={"center"} padding={"normal"}>
          <div className=" mb-2">Device History</div>
        </TableCell>

        <TableCell align={"center"} padding={"normal"}>
          <div className=" mb-2 ">Actions</div>
        </TableCell>
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const EnhancedTableToolbar = (props) => {
  const { numSelected } = props;

  return (
    //
    <div className="pt-10"></div>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

export default function Device() {
  const history = useHistory();
  let search = window.location.search;
  let params = new URLSearchParams(search);
  const [open, setOpen] = useState(false);
  const [show, setShow] = useState(false);
  const [editMode, seteditMode] = useState(false);
  const [deleteMode, setdeleteMode] = useState(false);
  const [showEditModal, setshowEditModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [devices, setDevices] = useState([]);
  const [name, setName] = useState("");
  const [editName, setEditName] = useState("");
  const [activeId, setactiveId] = useState("");
  const [fileValid, setFileValid] = useState(false);
  const [showDuplicate, setShowDuplicate] = useState(false);
  const [duplicateNameFile, setDuplicateNameFile] = useState([]);
  const [duplicateNameDataBase, setDuplicateNameDataBase] = useState([]);
  const [duplicateSerialFile, setDuplicateSerialFile] = useState([]);
  const [duplicateSerialDataBase, setDuplicateSerialDataBase] = useState([]);
  const [query, setQuery] = useState("");
  const [uploadedFile, setUploadedFile] = useState(null);
  const [clicked, setclicked] = useState(false);
  const [allocatedDevices, setAllocatedDevices] = useState(0);
  const [unallocatedDevices, setunAllocatedDevices] = useState(0);
  const [invalidNames, setInvalidNames] = useState([]);
  const [showHistory, setShowHistory] = useState(false);
  const [deviceHistory, setDeviceHistory] = useState([]);
  const [currPage, setCurrPage] = useState(0);
  const [paged, setPaged] = useState(0);
  const [noOfPages, setNoOfPages] = useState(0);
  const [serialId, setSerialId] = useState("");
  const [totalCount, setTotalCount] = useState(0);
  const [pageLimit, setPageLimit] = useState(25);
  const [snackBarShow, setSnackBarShow] = useState(false);
  const [snackBarMessage, setSnackBarMessage] = useState("");
  const [snackBarSeverity, setSnackBarSeverity] = useState("");
  const [myUser, setmyUser] = useState(userState);
  const logoutHandler = async () => {
    setTimeout(() => {
      setAdminCookie({
        fName: null,
        lName: null,
        token: null,
        userId: null,
      });
      let hostname = window.location.host;
      window.location.assign(
        `${window.location.protocol}//${hostname}/super-admin`
      );
    });
  };

  const feedBackMsg = (snackShow, snackSeverity, snackMessage) => {
    setSnackBarShow(snackShow);
    setSnackBarSeverity(snackSeverity);
    setSnackBarMessage(snackMessage);
  };

  const SnackClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    feedBackMsg(false, "", "");
  };

  const editHandler = async (e) => {
    e.preventDefault();
    let dataToSend = { name: editName };
    let res = await editDevice(activeId, dataToSend, myUser.token);
    if (res.error) {
      if (res.data.statusCode == 401) {
        logoutHandler();
      } else {
        feedBackMsg(true, "error", res?.data?.msg);
      }
    } else {
      feedBackMsg(true, "success", res?.res?.data?.msg);
      setactiveId("");
      setEditName("");
      handleCloseAddModal();
      history.replace({
        pathname: "/devices",
        search:
          "?page=" +
          paged +
          "&limit=" +
          pageLimit +
          "&search=" +
          query +
          "&orderBy=" +
          orderBy +
          "&order=" +
          order,
      });
      getDevice(paged, pageLimit, query, orderBy, order);
    }
  };
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const deleteHandler = async (e) => {
    e.preventDefault();
    let dataToSend = { name: editName };
    let res = await deleteDevice(activeId, myUser.token);
    if (res.error) {
      if (res.data.statusCode == 401) {
        logoutHandler();
      } else {
        feedBackMsg(true, "error", res.data.msg);
      }
    } else {
      setactiveId("");
      setEditName("");
      handleCloseAddModal();
      history.replace({
        pathname: "/devices",
        search:
          "?page=" +
          paged +
          "&limit=" +
          pageLimit +
          "&search=" +
          query +
          "&orderBy=" +
          orderBy +
          "&order=" +
          order,
      });
      getDevice(paged, pageLimit, query, orderBy, order);
      feedBackMsg(true, "success", res.res.data.msg);
    }
  };

  const fetchDeviceHistory = async (id) => {
    setLoading(true);
    let res = await DeviceHistory(id, myUser.token);
    if (res.error) {
      if (res.data.statusCode == 401) {
        logoutHandler();
      } else {
      }
      setLoading(false);
    } else {
      setLoading(false);
      if (res.res.data.data.status == "found") {
        setDeviceHistory(res.res.data.data.devicehistory);
        feedBackMsg(true, "success", res.res.data.msg);
        setLoading(false);
      } else {
      }
    }
  };

  const handleChangePage = (event, newPage) => {
    setPaged(event.selected);
    getDevice(event.selected, pageLimit, query, orderBy, order);
    history.replace({
      pathname: "/devices",
      search:
        "?page=" +
        event.selected +
        "&limit=" +
        pageLimit +
        "&search=" +
        query +
        "&orderBy=" +
        orderBy +
        "&order=" +
        order,
    });
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    let res = await createDevice(
      { name: name.trim(), serialId: serialId.trim() },
      myUser.token
    );
    if (res.error) {
      if (res.data.statusCode == 401) {
        logoutHandler();
      } else {
        feedBackMsg(true, "error", res.data.msg);

        setLoading(false);
      }
    } else {
      setLoading(false);
      history.replace({
        pathname: "/devices",
        search:
          "?page=" +
          paged +
          "&limit=" +
          pageLimit +
          "&search=" +
          query +
          "&orderBy=" +
          orderBy +
          "&order=" +
          order,
      });
      getDevice(paged, pageLimit, query, orderBy, order);
      handleCloseAddModal();

      feedBackMsg(true, "success", res.res.data.msg);
      //showModal(true)
    }
  };

  const getDeviceDetail = async (activeId, type) => {
    if (type === "edit") seteditMode(true);
    else setdeleteMode(true);
    setactiveId(activeId);
    handleShowAddModal();
    let res = await getDeviceDetails(activeId, myUser.token);
    if (res.error) {
      if (res.data.statusCode == 401) {
        logoutHandler();
      } else {
        feedBackMsg(true, "error", res.data.msg);
      }
    } else {
      setEditName(res.res.data.data.device.name);
    }
  };
const onSearch=(e)=>{
      history.replace({
        pathname: "/devices",
        search:
          "?page=" +
          0 +
          "&limit=" +
          pageLimit +
          "&search=" +
          e.target.value +
          "&orderBy=" +
          "updatedAt" +
          "&order=" +
          'desc',
      });
      setPaged(0);
      setPageLimit(pageLimit);
      setOrder(order);
      setOrderBy(orderBy);
      setQuery(e.target.value);
      getDevice(0, pageLimit, e.target.value, "updatedAt", "desc");
}
  useEffect(() => {
    const _cookie = getCookie("recoil-persist");
    if (!_cookie) {
      logoutHandler();
    } else {
      const user = JSON.parse(_cookie)["KT_app"];
      setmyUser(user);
      let urlPage = parseInt(params.get("page")) || 0;
      let urlLimit = parseInt(params.get("limit")) || pageLimit;
      let searchPage = params.get("search") || "";
      let urlOrder = params.get("order") || "desc";
      let urlOrderBy = params.get("orderBy") || 'createsdAt';
      if (parseInt(params.get("page")) || parseInt(params.get("limit"))) {
      history.replace({
        pathname: "/devices",
        search:
          "?page=" +
          urlPage +
          "&limit=" +
          urlLimit +
          "&search=" +
          searchPage +
          "&orderBy=" +
          urlOrderBy +
          "&order=" +
          urlOrder,
      });
      setPaged(urlPage);
      getDevice(urlPage, urlLimit, searchPage, urlOrderBy, urlOrder, user);
      setPageLimit(urlLimit);
      setQuery(searchPage);
      setOrder(urlOrder);}
      else{
        history.push({
          pathname: "/devices",
          search:
            "?page=" +
            0 +
            "&limit=" +
            pageLimit +
            "&search=" +
            query +
            "&orderBy=" +
            orderBy +
            "&order=" +
            order,
        });
        getDevice(0, pageLimit,query, orderBy, order, user);
        }
    }
  }, []);
  const getDevice = async (
    pages,
    limits,
    search,
    orderBy,
    order,
    user = myUser
  ) => {
    let res = await getAllDevice(
      user?.token,
      pages,
      limits,
      search,
      orderBy,
      order
    );
    if (res.error) {
      if (res.data.statusCode == 401) {
        logoutHandler();
      } else {
        feedBackMsg(true, "error", res.data.msg);
      }
    } else {
      let temp_devices = res?.res?.data?.data?.devices,
      
      arr = [];
      for (let i = 0; i < temp_devices.length; i++) {
        let obj = { ...temp_devices[i], name: temp_devices[i].name };
        arr.push(obj);
      }
     //console.log"res..",res);
     //console.log"temp_devices...",temp_devices)
      setDevices(arr);
      setAllocatedDevices(res?.res?.data?.data?.allocatedCount);
      setunAllocatedDevices(res?.res?.data?.data?.unallocatedCount);
      setTotalCount(res?.res?.data?.data?.allocatedCount + res?.res?.data?.data?.unallocatedCount);
      let divisor = parseInt(res.res.data.data.totalcount / limits);
      let remainder = parseInt(
        res.res.data.data.totalcount % limits == 0 ? 0 : 1
      );
      setNoOfPages(divisor + remainder);
      setCurrPage(pages);
      if (res.res.data.data.totalcount == 0) {
        setPaged(0);
      }
    }
  };
  const handleCloseAddModal = () => {
    setShow(false);
    seteditMode(false);
    setName("");
    setSerialId("");
    setdeleteMode(false);
  };
  const handleShowAddModal = () => {
    setShow(true);
  };
  const handleCloseEditModal = () => {
    setShow(false);
    seteditMode(false);
  };

  const handleBulk = async (e) => {
    e.preventDefault();
    if (!uploadedFile) {
      return;
    }
    setclicked(true);
    const formData = new FormData();
    formData.append("file", uploadedFile, "file");
    const res = await bulkcreateDevice(formData, myUser.token);
    if (res.error) {
      if (res.data.statusCode == 401) {
        logoutHandler();
      } else {
        feedBackMsg(true, "error", res.data.msg);
      }
    } else {
      // feedBackMsg(true,'success',res.res.data.msg);
      if (
        res?.res?.data?.data?.duplicateEntryNameinFile?.length > 0 ||
        res?.res?.data?.data?.fiveExceedlist?.length > 0 ||
        res?.res?.data?.data?.duplicateEntrySerialinDatabase?.length > 0 ||
        res?.res?.data?.data?.duplicateEntryNameinDatabase?.length > 0 ||
        res?.res?.data?.data?.duplicateEntrySerialinFile?.length > 0
      ) {
        let duplicateIds = res?.res?.data?.data?.duplicateEntryNameinFile;
        setShowDuplicate(true);
        setDuplicateNameFile(duplicateIds);
        setDuplicateNameDataBase(
          res?.res?.data?.data?.duplicateEntryNameinDatabase
        );
        setDuplicateSerialDataBase(
          res?.res?.data?.data?.duplicateEntrySerialinDatabase
        );
        setDuplicateSerialFile(res?.res?.data?.data?.duplicateEntrySerialinFile);
        setInvalidNames(res?.res?.data?.data?.fiveExceedlist);
      }
    }
    setclicked(false);
    handleClose();
      history.replace({
        pathname: "/devices",
        search:
          "?page=" +
          paged +
          "&limit=" +
          pageLimit +
          "&search=" +
          query +
          "&orderBy=" +
          orderBy +
          "&order=" +
          order,
      });
    getDevice(paged, pageLimit, query, orderBy, order);
  };

  const [order, setOrder] = React.useState("desc");
  const [orderBy, setOrderBy] = React.useState("updatedAt");
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(pageLimit);
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };
  const onSetOrder = (event, property) => {
    let orderTemp = order === "asc" ? "desc" : "asc";
    let urlPage = parseInt(params.get("page")) || 0;
    let urlLimit = parseInt(params.get("limit")) || 25;
    let searchPage = params.get("search") || "";
    history.replace({
      pathname: "/devices",
      search:
        "?page=" +
        urlPage +
        "&limit=" +
        urlLimit +
        "&search=" +
        searchPage +
        "&orderBy=" +
        property +
        "&order=" +
        orderTemp,
    });
    setPaged(urlPage);
    getDevice(urlPage, urlLimit, searchPage, property, orderTemp, myUser);
    setPageLimit(urlLimit);
    setQuery(searchPage);
    setOrder(orderTemp);
    setOrderBy(property);
  };
  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = devices.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const handleFile = (e) => {
    if (e?.target?.files[0]?.name?.includes(".csv")) {
      const file = e?.target?.files;
      setUploadedFile(e?.target?.files[0]);
      setFileValid(true);
    } else {
      e.target.value = ""; 
      alert("Please enter a csv file");
      setUploadedFile(null);
      setFileValid(false);
    }
  };

  const handleClose1 = () => {
    setShowDuplicate(false);
  };
const onDownloadSampleCsv=async()=>{
  const _cookie = getCookie("recoil-persist");
    if (!_cookie) {
      logoutHandler();
    } else {
      const user = JSON.parse(_cookie)["KT_app"];
     if(user){let res = await downloadSampleCsv(user.token);}}
}
  const handleChangeRowsPerPage = (event) => {
    setPageLimit(parseInt(event.target.value, 10));
    setPaged(0);
    getDevice(0, parseInt(event.target.value, 10), query, orderBy, order);
    history.push({
      pathname: "/devices",
      search:
        "?page=0" +
        "&limit=" +
        parseInt(event.target.value, 10) +
        "&search=" +
        query +
        "&orderBy=" +
        orderBy +
        "&order=" +
        order,
    });
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - devices?.length) : 0;

  return (
    <section id="hero-school ">
      <Dialog
        open={showHistory}
        handleClose={() => {
          setShowHistory(false);
          setDeviceHistory([]);
        }}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>
          <Grid container justify="space-between" alignItems="center">
            <Typography variant="h6" style={{ fontWeight: "600" }}>
              Manage Devices
            </Typography>
            <IconButton
              onClick={() => {
                setShowHistory(false);
                setDeviceHistory([]);
              }}
            >
              <CloseIcon
                style={{ border: "2px solid black", fontSize: "30px" }}
              />
            </IconButton>
          </Grid>
        </DialogTitle>

        <div className="flex-container">
          {
            <TableContainer
              className="container table"
              style={{ maxHeight: "500px" }}
            >
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    <TableCell>Device Id</TableCell>
                    <TableCell>Category</TableCell>
                    <TableCell>Category Id</TableCell>
                    <TableCell>Date</TableCell>
                    <TableCell>Status</TableCell>
                  </TableRow>
                </TableHead>

                {loading && !deviceHistory?.length && <CircularProgress />}
                {!loading && !deviceHistory?.length && (
                  <p>No Device History Found</p>
                )}

                <TableBody>
                  {deviceHistory?.length > 0 &&
                    deviceHistory.map((item, index) => {
                      return (
                        <TableRow
                          hover
                          key={index}
                          role="checkbox"
                          tabIndex={-1}
                        >
                          <TableCell className="table-data">
                            {item.device._id}
                          </TableCell>
                          <TableCell className="table-data">
                            {item.allocatedTo}
                          </TableCell>{" "}
                          <TableCell className="table-data">
                            {item.allocationId}
                          </TableCell>{" "}
                          <TableCell className="table-data">
                            {/* { dayjs(item.updatedAt).format('DD/MM/YYYY  hh:mm:A') } */}
                            {`${new Date(
                              item.updatedAt
                            ).toLocaleDateString()} ${new Date(
                              item.updatedAt
                            ).toLocaleTimeString()}`}
                          </TableCell>
                          <TableCell className="table-data">
                            {item.status}
                          </TableCell>{" "}
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
          }
        </div>
      </Dialog>

      <Dialog
        scroll="paper"
        open={showDuplicate}
        onClose={handleClose1}
        fullWidth
      >
        <DialogTitle>Duplicate LoginIds/ Device Name Exceed List</DialogTitle>
        <DialogContent>
          {duplicateNameFile.length > 0 ? (
            <>
              <br />
              <h6>Duplicate Device Names in File</h6>
              <br></br>
            </>
          ) : null}
          {duplicateNameFile.map((e, i) => {
            return (
              <div>
                {i + 1}. {e}
              </div>
            );
          })}

          {duplicateNameDataBase.length > 0 ? (
            <>
              <br />
              <h6>These Device names are already present in Database.</h6>
              <br></br>
            </>
          ) : null}
          {duplicateNameDataBase.map((e, i) => {
            return (
              <div>
                {i + 1}. {e}
              </div>
            );
          })}

          {duplicateSerialFile.length > 0 ? (
            <>
              <br />
              <h6>Duplicate Serial Id in File.</h6>
              <br></br>
            </>
          ) : null}
          {duplicateSerialFile.map((e, i) => {
            return (
              <div>
                {i + 1}. {e}
              </div>
            );
          })}

          {duplicateSerialDataBase.length > 0 ? (
            <>
              <br />
              <h6>These Serial Ids are already present in Database.</h6>
              <br></br>
            </>
          ) : null}
          {duplicateSerialDataBase.map((e, i) => {
            return (
              <div>
                {i + 1}. {e}
              </div>
            );
          })}

          {invalidNames.length > 0 ? (
            <>
              <br />
              <h6>
                These Device names either exceeded more than 15 letters or were
                less than 5 characters{" "}
              </h6>
              <br></br>
              {invalidNames.map((e, i) => {
                return (
                  <div>
                    {i + 1}. {e}
                  </div>
                );
              })}
            </>
          ) : null}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose1}>Close</Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title"></DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <form onSubmit={(e) => handleBulk(e)}>
              <h3 className="custom-form-heading">Add Devices from Excel</h3>
              <input
                type="file"
                className="custom-form-input"
                required
                onChange={handleFile}
              />
              {!clicked && (
                <input
                  type="submit"
                  className="custom-form-button"
                  value="Upload"
                  disabled={!fileValid}
                />
              )}
              {clicked && (
                <button className="custom-form-button" disabled>
                  Uploading...
                </button>
              )}
            </form>
            {/* <br/> */}
            {/* <div onClick={openDocs} style={{color:'blue'}}>
              Download Sample
          </div> */}
             {/* <a href={`${baseUrl}/download-csv`}  rel="noopener noreferrer">
      Download Sample File
    </a> */}
          <Button variant="text" sx={{textTransform:'none'}} onClick={onDownloadSampleCsv}> Download Sample File </Button>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
        </DialogActions>
      </Dialog>

      <Dialog handleClose={handleCloseAddModal} open={show} fullWidth>
        {!editMode && !deleteMode ? (
          <>
            <DialogTitle>
              <Grid container justify="space-between" alignItems="center">
                <Typography variant="h6" style={{ fontWeight: "600" }}>
                  Add Device
                </Typography>
                <IconButton onClick={handleCloseAddModal}>
                  <CloseIcon
                    style={{ border: "2px solid black", fontSize: "30px" }}
                  />
                </IconButton>
              </Grid>
            </DialogTitle>
            <div className="col-md-9 text-left  col-9 m-auto">
              <div className="form-group mt-4   p-20">
                <input
                  maxLength="15"
                  type="text"
                  value={name}
                  className="form-control"
                  onBlur={(e) => setName(e.target.value.trim())}
                  placeholder="Device Name"
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
              <div className="form-group mt-4   p-20">
                <input
                  maxLength="32"
                  type="text"
                  value={serialId}
                  onBlur={(e) => setSerialId(e.target.value.trim())}
                  className="form-control"
                  placeholder="Device Serial Id"
                  onChange={(e) => setSerialId(e.target.value)}
                />
              </div>

              <div className="form-group p-20">
                <button
                  onClick={submitHandler}
                  type="submit"
                  className="cta-btn"
                  disabled={
                    name.trim().length < 1 || serialId.trim().length < 1
                  }
                >
                  {loading ? <CircularProgress /> : "Add"}
                </button>
              </div>
            </div>
          </>
        ) : editMode ? (
          <>
            <DialogTitle>
              <Grid container justify="space-between" alignItems="center">
                <Typography variant="h6" style={{ fontWeight: "600" }}>
                  Edit Device
                </Typography>
                <IconButton onClick={handleCloseAddModal}>
                  <CloseIcon
                    style={{ border: "2px solid black", fontSize: "30px" }}
                  />
                </IconButton>
              </Grid>
            </DialogTitle>
            <div className="col-md-9 text-left  col-9 m-auto">
              <div className="form-group mt-4   p-20">
                <input
                  value={editName}
                  maxLength="15"
                  type="text"
                  onBlur={(e) => setEditName(e.target.value.trim())}
                  className="form-control"
                  placeholder="Device ID"
                  onChange={(e) => setEditName(e.target.value)}
                />
              </div>

              <div className="form-group p-20">
                <button onClick={editHandler} type="submit" className="cta-btn">
                  {loading ? <CircularProgress /> : "Edit"}
                </button>
              </div>
            </div>
          </>
        ) : (
          <>
            <DialogTitle>
              <Grid container justify="space-between" alignItems="center">
                <Typography variant="h6" style={{ fontWeight: "600" }}>
                  Remove Device
                </Typography>
                <IconButton onClick={handleCloseAddModal}>
                  <CloseIcon
                    style={{ border: "2px solid black", fontSize: "30px" }}
                  />
                </IconButton>
              </Grid>
            </DialogTitle>
            <div className="col-md-9 text-left  col-9 m-auto">
              <div className="form-group mt-4   p-20">
                <h4>Are you sure to Remove this Device?</h4>
              </div>
              <div className="form-group mt-4   p-20">
                <input
                  readOnly
                  value={editName}
                  type="text"
                  className="form-control"
                  placeholder="Device ID"
                />
              </div>

              <div className="form-group p-20">
                <button
                  onClick={deleteHandler}
                  type="submit"
                  className="cta-btn-red"
                >
                  {loading ? <CircularProgress /> : "Delete"}
                </button>
              </div>
            </div>
          </>
        )}
      </Dialog>

      <div>
        <NavBar />
        <div className="mt-5">
          <h2>All Devices</h2>
        </div>
        <div className="dashboard-notification-cards mt-1">
          <div className="notification-card-admin p-3">
            <h2>{totalCount}</h2>

            <h6 className="ml-2 notification-subHeading span-h4">Total</h6>
          </div>
          <div className="notification-card-admin p-3">
            <h2>{allocatedDevices}</h2>

            <h6 className="ml-2 notification-subHeading span-h4">Allocated</h6>
          </div>
          <div className="notification-card-admin p-3">
            <h2>{unallocatedDevices}</h2>

            <h6 className="ml-2 notification-subHeading span-h4">
              Unallocated
            </h6>
          </div>
        </div>
        <div className="dashboard-heading " style={{ marginRight: "20px" }}>
          <h2>
            Devices List
            <Link onClick={handleShowAddModal}>
              <button className="btn btn-add-device float-right ">
                <i className="fas fa-plus-circle"></i> {"  "}
                <span>Add new Device</span>
              </button>
            </Link>
            <Link onClick={() => handleClickOpen()}>
              <button className="btn btn-add-device float-right ">
                <i className="fas fa-cloud-upload-alt"></i> {"  "}
                <span>Upload Item In Bulk</span>
              </button>
            </Link>
          </h2>
        </div>

        <div>
          <div className="row">
            <div className="col-lg-8 col-md-7 col-sm-12">
              <TextField
                sx={{ minWidth: 250, width: 600, background: "white" }}
                value={query}
                id="outlined-search"
                label="Search"
                type="search"
                onBlur={(e) => {
                  setQuery(e.target.value.trim());
                }}
                onChange={onSearch}
              />
            </div>
          </div>
          <br />
          <div className="d-flex justify-content-end align-items-end">
            <ReactPaginate
              previousLabel="Previous"
              nextLabel="Next"
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              breakLabel="..."
              breakClassName="page-item"
              breakLinkClassName="page-link"
              pageCount={noOfPages}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={handleChangePage}
              containerClassName="pagination"
              activeClassName="activePage active"
              forcePage={currPage}
            />
          </div>
          {/* <div className="d-flex justify-content-end align-items-end">

            <Box sx={{ minWidth: 100,backgroundColor:"white"}} >
                      <FormControl fullWidth size="small">
                        <InputLabel id="demo-simple-select-label">Page</InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={pageLimit}
                          label="Age"
                          onChange={handleChangeRowsPerPage}
                          >
                            <MenuItem value={10}>10</MenuItem>
                            <MenuItem value={20}>20</MenuItem>
                            <MenuItem value={50}>50</MenuItem>
                            <MenuItem value={100}>100</MenuItem>
                           
                        </Select>
                      </FormControl>
                    </Box>
            </div>   */}

          {/* <table className="table">
            <thead>
              <tr>
                <th>Serial Id</th>
                <th>Device Name</th>
                <th>School District</th>
                <th>School</th>
                <th>Teacher</th>
                <th>Assigned on</th>
                <th>Device History</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {devices.map((item, index) => {

                  if(item._id.toLowerCase().includes(query.toLowerCase()) || item?.name?.includes(query.toLowerCase())){
                    return <tr hover key={index} role="checkbox" tabIndex={-1}>
                    <td className="">
                    <Link className="sec-link" to={`/experiments?serial=${item._id}`}>{item._id}</Link>
                      </td>
                    <td className="">
                      {item.name}
                    </td>{" "}
                    <td className="" style={{ textTransform: 'capitalize' }}><Link className="sec-link" to={(item?.schoolDistrict?.schoolId==undefined)?`/district/${item?.schoolDistrict?._id}`:`/district/${item?.schoolDistrict?._id}/school/${item?.school?._id}`}>{item?.schoolDistrict?.name}</Link></td>
                    <td className="" style={{ textTransform: 'capitalize' }}><Link className="sec-link" to={`/district/${item?.schoolDistrict?._id}/school/${item?.school?._id}`}>{item?.school?.name}</Link></td>
                    <td className="" style={{ textTransform: 'capitalize' }}>
                      {item?.teacher?.map(teach => {
                        return <li key={teach._id}
                          className="sec-link">
                        
                        
                          {`${teach?.fName} ${teach?.lName}`}
                        </li>
                      })}
                    </td>
                    <td className="table-data dateShow">{(item.schoolDistrict || item.school || item.teacher.length>0)?
                      (item.assignedAt==undefined)?`${new Date(item.updatedAt).toLocaleDateString()} ${new Date(item.updatedAt).toLocaleTimeString()}`
                        :`${new Date(item.assignedAt).toLocaleDateString()} ${new Date(item.assignedAt).toLocaleTimeString()}`:'-'}
                    </td>
                    <td>
                      <Link onClick={()=>{setShowHistory(true);fetchDeviceHistory(item._id)}}>Show</Link>
                    </td>
                    <td className="">
                    <Tooltip title="Edit" placement="top">
                      <Link>
                       
                        <span onClick={() => {
                          getDeviceDetail(item._id,'edit');
                        }}>
                          <i className="fas fa-edit icon-size-20" ></i>
                        </span>
                      </Link>
                      </Tooltip>
                      &nbsp;
                      <Tooltip title="Delete" placement="top">
                      <Link>
                      
                        <span onClick={() => {
                          getDeviceDetail(item._id,'delete');
                        }}>
                          <i className="fas fa-trash-alt icon-size-20" ></i>
                        </span>
                      </Link>
                      </Tooltip>
                    </td>

                  </tr>
                  }
                  
              })}
            </tbody>
          </table> */}

          <Box sx={{ width: "100%" }}>
            <Paper sx={{ width: "100%", mb: 2 }}>
              <EnhancedTableToolbar numSelected={selected.length} />
              <TableContainer className="scrollLimits">
                <Table
                  sx={{ minWidth: 750 }}
                  aria-labelledby="tableTitle"
                  size={"small"}
                  stickyHeader
                >
                  <EnhancedTableHead
                    numSelected={selected.length}
                    order={order}
                    orderBy={orderBy}
                    onSelectAllClick={handleSelectAllClick}
                    onRequestSort={onSetOrder}
                    rowCount={devices.length}
                  />
                  <TableBody>
                    {devices?.map((devices, index) => {
                      const isItemSelected = isSelected(devices?.name);
                      const labelId = `enhanced-table-checkbox-${index}`;
                      return (
                        <TableRow
                          hover
                          onClick={(event) => handleClick(event, devices?.name)}
                          role="checkbox"
                          aria-checked={isItemSelected}
                          tabIndex={-1}
                          key={(devices?.name || "xyz") + index.toString()}
                          selected={isItemSelected}
                        >
                          <TableCell align="center">
                            <Link className="sec-link" to={`/experiments?serial=${devices?._id}`} >
                              {devices?._id}
                            </Link>
                          </TableCell>
                          <TableCell align="right">
                            {devices?.name ? (
                              <>
                                <span>{devices?.name}</span>
                              </>
                            ) : (
                              <>
                                <span
                                  style={{
                                    backgroundColor: "#960018",
                                    color: "white",
                                  }}
                                >
                                  No Name
                                </span>
                              </>
                            )}
                          </TableCell>
                          <TableCell align="right">
                            {/* {experiments.deviceName || experiments?.device?.name} */}
                            <Link
                              className="sec-link"
                              to={
                                devices?.schoolDistrict?.schoolId == undefined
                                  ? `/district/${devices?.schoolDistrict?._id}`
                                  : `/district/${devices?.schoolDistrict?._id}/school/${devices?.school?._id}`
                              }
                            >
                              {devices?.schoolDistrict?.name}
                            </Link>
                          </TableCell>
                          <TableCell align="right">
                            <Link
                              className="sec-link"
                              to={`/district/${devices?.schoolDistrict?._id}/school/${devices?.school?._id}`}
                            >
                              {devices?.school?.name}
                            </Link>
                          </TableCell>
                          <TableCell align="right">
                            {devices?.teacher?.map((teach) => {
                              return (
                                <li key={teach._id} className="sec-link">
                                  {`${teach?.fName} ${teach?.lName}`}
                                </li>
                              );
                            })}
                          </TableCell>
                          <TableCell align="right">
                            {devices?.schoolDistrict ||
                            devices?.school ||
                            devices?.teacher?.length > 0
                              ? devices?.assignedAt == undefined
                                ? `${new Date(
                                    devices?.updatedAt
                                  ).toLocaleDateString()} ${new Date(
                                    devices?.updatedAt
                                  ).toLocaleTimeString()}`
                                : `${new Date(
                                    devices?.assignedAt
                                  ).toLocaleDateString()} ${new Date(
                                    devices?.assignedAt
                                  ).toLocaleTimeString()}`
                              : "-"}
                          </TableCell>
                          <TableCell align="right">
                            <Link
                              onClick={() => {
                                setShowHistory(true);
                                fetchDeviceHistory(devices?._id);
                              }}
                            >
                              Show
                            </Link>
                          </TableCell>
                          <TableCell align="right">
                            <Tooltip title="Edit" placement="top">
                              <Link>
                                <span
                                  onClick={() => {
                                    getDeviceDetail(devices?._id, "edit");
                                  }}
                                  style={{ fontSize: "25px" }}
                                >
                                  <i className="fas fa-edit icon-size-20"></i>
                                </span>
                              </Link>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                    {emptyRows > 0 && (
                      <TableRow
                        style={{
                          height: (dense ? 33 : 53) * emptyRows,
                        }}
                      >
                        <TableCell colSpan={6} />
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          </Box>
        </div>
      </div>

      <Snackbar
        open={snackBarShow}
        autoHideDuration={3000}
        onClose={SnackClose}
      >
        <Alert
          onClose={SnackClose}
          severity={snackBarSeverity}
          sx={{ width: "100%" }}
        >
          {snackBarMessage}
        </Alert>
      </Snackbar>
    </section>
  );
}
